import type { CustomerPriceBreakdown, PricingV2 } from "@b2bportal/lodging-api";
import { LodgingSelectors } from "@checkout/states";

/**
 * The FTC/EAN-compliant price breakdown. Quote exposes it as `PricingV2`; shop
 * expose the same data as `CustomerPriceBreakdown`. All amounts are pre-computed
 * by the backend — never derive prices here.
 */
export type RbcLodgingPriceBreakdown = PricingV2 | CustomerPriceBreakdown;

type SelectorState = Parameters<
  typeof LodgingSelectors.getQuotedLodgingProduct
>[0] &
  Parameters<typeof LodgingSelectors.getSelectedRoomProduct>[0];

/**
 * Resolve the compliant price breakdown, quote-first. RBC's quote is always a
 * `PriceQuoteV2`, whose compliant object is `pricingV2`. Before the quote (or if
 * `pricingV2` is absent) fall back to the shop `RoomProduct.customerPriceBreakdown`.
 */
export const getRbcLodgingPriceBreakdown = (
  state: SelectorState
): RbcLodgingPriceBreakdown | undefined => {
  const quotedProduct = LodgingSelectors.getQuotedLodgingProduct(state);

  if (
    quotedProduct?.LodgingPriceQuote === "PriceQuoteV2" &&
    quotedProduct.pricingV2 != null
  ) {
    return quotedProduct.pricingV2;
  }

  return LodgingSelectors.getSelectedRoomProduct(state)?.customerPriceBreakdown;
};
